import { Component, Renderer2, HostListener, ViewChild, ElementRef, OnInit } from '@angular/core';
import { AppGlobal } from './app.global';
import { Title, Meta } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { GoogleService } from './google.service';
import { ConnexionService } from './connexion.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  showLeftNavbar = false;
  @ViewChild('footer') footer: ElementRef;
  iframe: boolean;

  showHeaderAndFooter: boolean;

  // template spécial pour le site partenaire Linxea
  linxea: boolean;
  lmp: boolean;

  bgfinance: boolean;

  copyright: string;

  lastUrl = '';

  phone: string;

  ashler: boolean;

  logoHeaderEnabled: boolean;
  logoFooterEnabled: boolean;
  novelia: boolean;

  courtierInfo: string;

  constructor(private renderer: Renderer2, private appGlobal: AppGlobal, private title: Title, private router: Router,
    private meta: Meta, private googleService: GoogleService, private connexionService: ConnexionService) {
    window.onbeforeunload = function(e) {
      return false;
    };
    this.iframe = this.appGlobal.isIframe();
    this.bgfinance = this.appGlobal.isBgfinance();
    this.phone = this.appGlobal.getPhone();
    this.ashler = this.appGlobal.isAshlerManson();
    this.novelia = this.appGlobal.isNovelia();

    this.courtierInfo = this.appGlobal.getCourtierInfo();

    this.logoFooterEnabled = this.appGlobal.isLogoFooterEnabled();
    this.logoHeaderEnabled = this.appGlobal.isLogoHeaderEnabled();

    this.title.setTitle(this.appGlobal.getTitle());
    this.meta.updateTag({
      name: 'description',
      content: this.appGlobal.getMetaDescription()
    });

    this.router.events.subscribe(event => {
      if (environment.production && event instanceof NavigationEnd) {
        //if (this.lastUrl !== '') this.googleService.sendEvent('ALLER A ' + event.urlAfterRedirects, this.lastUrl);
        this.googleService.pageView(event.urlAfterRedirects);
        this.lastUrl = event.urlAfterRedirects;
      }
    });

    console.log(window.location.host);
    if (window.location.host == 'catcafpileadsweb.multinet-inside.fr' || window.location.host == 'cafpileadsweb.multinet-inside.fr') {
      this.connexionService.setLogin("c.leadweb@cafpi.fr");
      this.appGlobal.setUniqueId("c.leadweb@cafpi.fr");
      
      document.documentElement.style.setProperty('--primary-color', '#32464B');
      document.documentElement.style.setProperty('--primary-color-hover', '#29454d');
      document.documentElement.style.setProperty('--secondary-color', '#F09600');
      document.documentElement.style.setProperty('--secondary-color-hover', '#ce8405');
      environment.primaryColor = '#32464B';
      environment.secondaryColor = '#F09600';
      this.appGlobal.setShowHeaderAndFooter(false);
      this.appGlobal.setDistributor('CAFPI');

      this.appGlobal.setProfiles('BO_CAFPI');

      if (window.location.host == 'catcafpileadsweb.multinet-inside.fr') 
        this.appGlobal.setOriginUrl('https://natwww.accelerassur.fr');
      else 
        this.appGlobal.setOriginUrl('https://www.accelerassur.fr');
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    this.googleService.sendEvent('session_end',this.lastUrl)
  }

  ngOnInit() {
    if (!this.appGlobal.isIframe() && environment.codeApporteur != 'QUICKWIN') this.changeBodyMarginBottom();
    this.linxea = this.appGlobal.isLinxea();
    this.lmp = this.appGlobal.isLmp();
    this.copyright = this.appGlobal.getCopyright();
  }

  ngAfterViewInit() {
    const splashScreen: HTMLElement = document.getElementById('splashScreenClass');
    if (splashScreen) {
      splashScreen.remove();
    }

    this.showHeaderAndFooter = this.appGlobal.isShowHeaderAndFooter();
    if (!this.showHeaderAndFooter)
      this.renderer.setStyle(this.footer.nativeElement, 'visibility', 'hidden');
  }

  onActivate() {
    window.scrollTo(0, 0);
  }

  toggleLeftNavbar(): void {
    this.showLeftNavbar = !this.showLeftNavbar;
  }

  changeBodyMarginBottom() {
    console.log('> changeBodyMarginBottom');
    const footerHeight = this.footer.nativeElement.offsetHeight;
    this.renderer.setStyle(document.body, 'margin-bottom', footerHeight + 'px');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.changeBodyMarginBottom();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts